import {
  faCheckSquare,
  faSquare,
  faPhone,
  faTimes,
  faChevronUp,
  faChevronRight,
  faChevronDown,
  faPencilAlt,
  faEdit,
  faCheck,
  faPlus,
  faTrashAlt,
  faAngleDoubleRight,
  faAngleDoubleDown,
  // <i className={openId === wishlist._id ? "fas fa-angle-double-down" : "fas fa-angle-double-right"} />
} from "@fortawesome/free-solid-svg-icons";
import {
  faSquare as faSquareRegular,
  faCheckSquare as faCheckSquareRegular,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import SVG from "react-inlinesvg";

import filtersIcon from "../shapes/filters.svg";

const icons = {
  faCheckSquareRegular: { type: "fa", icon: faCheckSquareRegular },
  faSquareRegular: { type: "fa", icon: faSquareRegular },
  faCheckSquare: { type: "fa", icon: faCheckSquare },
  faSquare: { type: "fa", icon: faSquare },
  faChevronUp: { type: "fa", icon: faChevronUp },
  faChevronRight: { type: "fa", icon: faChevronRight },
  faChevronDown: { type: "fa", icon: faChevronDown },
  faTimes: { type: "fa", icon: faTimes },
  pencil: { type: "fa", icon: faPencilAlt },
  pencilWithSquare: { type: "fa", icon: faEdit },
  doubleArrowRight: { type: "fa", icon: faAngleDoubleRight },
  doubleArrowDown: { type: "fa", icon: faAngleDoubleDown },
  check: { type: "fa", icon: faCheck },
  plus: { type: "fa", icon: faPlus },
  trash: { type: "fa", icon: faTrashAlt },
  phone: { Component: IconPhone },
  filters: { type: "svg", icon: filtersIcon },
};

export default function Icon({ id, size, ...props }) {
  if (!icons[id]) return null;

  if (icons[id].type === "fa") {
    return <FontAwesomeIcon style={{ height: size }} icon={icons[id].icon} {...props} />;
  }

  if (icons[id].type === "svg") {
    return <SVG style={{ height: size }} src={icons[id].icon} {...props} />;
  }

  if (icons[id].Component) {
    const Component = icons[id].Component;
    return <Component size={size} {...props} />;
  }

  return null;
}

function IconPhone({ size = 24, className, ...props }) {
  return (
    <span className=" t-flex ">
      <FontAwesomeIcon
        className={className + " t-rounded-full "}
        style={{ padding: "20%", height: size, width: size }}
        icon={faPhone}
        flip="horizontal"
        {...props}
      />
    </span>
  );
}
